export const locale = {
  agreement: 'I have read the above agreement.',
  modal_title: 'You are required to sign a supplemental waiver.',
  cancel: 'DISAGREE/DECLINE',
  accept: 'AGREE',
};
